// Module
var code = "<v-card>    \n    <h1>{{valueText}}</h1>\n</v-card>\n";
// Exports
module.exports = code;